import type { ResizerPlacement } from '@frameio/vapor';
import { theme } from '@frameio/vapor-theme';

export const PRIMARY_NAV_BUTTON_TOOLTIP_PROPS = {
  placement: 'right' as ResizerPlacement,
} as Record<string, unknown>;

export const PRIMARY_NAV_COLLAPSED_WIDTH = 64;

export const PRIMARY_NAV_EXPANDED_WIDTH = 256;

// @todo (find-2375): Determine what the correct z-index should be. The nav needs to sit above all UI with the new flyout state, but below all modals/dialogs etc
export const PRIMARY_NAV_Z_INDEX = theme.zIndices.overlay + 60;

export const PRIMARY_NAV_DURATION = 200;
